import React from 'react';
import { Pencil } from 'lucide-react';
import EventDetailView from '../components/EventDetailView';
import ScreenHeader from '../components/ScreenHeader';

export default function DetailScreen({
  selectedEvent,
  lastScreen,
  setCurrentScreen,
  onEdit,
}) {
  const isEditable = selectedEvent?.source !== 'apple';

  return (
    <div className="h-full flex flex-col">
      <ScreenHeader
        title="Event Details"
        onBack={() => setCurrentScreen(lastScreen || 'home')}
        rightAction={isEditable && onEdit ? (
          <button onClick={onEdit} className="p-2 hover:bg-gray-100 rounded-lg">
            <Pencil size={20} className="text-blue-600" />
          </button>
        ) : undefined}
      />
      <EventDetailView event={selectedEvent} />
    </div>
  );
}
